import { createStore } from "vuex";
import company from "./modules/company";
import ui from "./modules/ui";
import admin from "./modules/admin";

export default createStore({
  modules: {
    company,
    ui,
    admin,
  },
});
